import request from '@/sheep/request';

export interface VipPackage {
	id : number;
	name : string;
	duration : number; // 时长（月）
	originalPrice : number; // 原价
	price : number; // 现价
	tag ?: string; // 标签，如"热卖"、"推荐"
	benefits : string[]; // 套餐权益列表
}

export interface VipOrder {
	orderId : number;
	packageId : number;
	price : number;
}

// 获取VIP套餐列表
export const getVipPackages = async () => {
	return request({
		url: '/pay/wallet-recharge-package/list',
		method: 'GET',
		custom: {
			showLoading: true,
			auth: true,
		},
	});
};

// 创建VIP订单
export const createVipOrder = async (data : { packageId : number }) => {
	return request({
		url: '/pay/vip/create-order',
		method: 'POST',
		data,
		custom: {
			showLoading: true,
			auth: true,
		},
	});
};

// 获取VIP订单支付信息
export const getVipPayInfo = async (orderId : number) => {
	return request({
		url: '/pay/vip/pay-info',
		method: 'GET',
		params: { orderId },
		custom: {
			showLoading: true,
			auth: true,
		},
	});
};

// 查询VIP订单状态
export const queryVipOrderStatus = async (orderId : number) => {
	return request({
		url: '/pay/vip/order-status',
		method: 'GET',
		params: { orderId },
		custom: {
			showLoading: false,
			auth: true,
		},
	});
};

// 获取VIP权益说明
export const getVipBenefits = async () => {
	return request({
		url: '/pay/vip/benefits',
		method: 'GET',
		custom: {
			showLoading: false,
		},
	});
};